// Brumy Make Up · aparición suave de los bloques al hacer scroll
(function () {
  // Cada sección Brumy carga este archivo: que solo arranque una vez
  if (window.brumyAparece) return;
  window.brumyAparece = true;
  var reducir = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reducir || !('IntersectionObserver' in window)) return;
  document.documentElement.classList.add('brumy-js');

  var observador = new IntersectionObserver(function (entradas) {
    entradas.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('is-visible');
        observador.unobserve(e.target);
      }
    });
  }, { rootMargin: '0px 0px -10% 0px' });

  function vigilar() {
    document.querySelectorAll('.brumy-aparece:not(.is-visible)').forEach(function (el) { observador.observe(el); });
  }
  vigilar();
  // El editor de Shopify vuelve a pintar secciones al cambiarlas
  document.addEventListener('shopify:section:load', vigilar);
})();
